const LARGE_WIDTH = 992;

export const isMobile = () => {
    const documentWidth = document.body.clientWidth;

    return LARGE_WIDTH > documentWidth;
};